import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  FEATURED_PROGRAM_FALLBACKS,
  PROGRAM_CAPTION_PATTERN,
} from '../../data/homepageLifeSlides';
import { resolveMediaUrl } from '../../utils/mediaUrl';

const API_BASE = process.env.REACT_APP_API_URL || '/api';
const MAX_CARDS = 6;

function pickFeaturedItems(items) {
  const photos = (Array.isArray(items) ? items : []).filter((i) => i.imageUrl);
  const matched = photos.filter((p) =>
    PROGRAM_CAPTION_PATTERN.test((p.caption || '').toLowerCase())
  );
  const pool = matched.length >= 4 ? matched : photos;
  return pool.slice(0, MAX_CARDS);
}

function FeaturedProgramsSection() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    fetch(`${API_BASE}/social-feed?paginate=1&offset=0&limit=24`)
      .then((res) => (res.ok ? res.json() : { items: [] }))
      .then((data) => {
        if (!cancelled) {
          setItems(pickFeaturedItems(data.items));
          setLoading(false);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setItems([]);
          setLoading(false);
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const cards = useMemo(() => {
    if (items.length > 0) {
      return items.map((item, i) => ({
        id: item.id || `feed-${i}`,
        title: (item.caption || '').trim().slice(0, 60) || 'Közösségi program',
        tag: 'Program',
        imageUrl: item.imageUrl,
      }));
    }
    return FEATURED_PROGRAM_FALLBACKS.map((f, i) => ({
      id: `fallback-${i}`,
      title: f.title,
      tag: f.tag,
      imageUrl: null,
    }));
  }, [items]);

  return (
    <section className="featured-programs-section">
      <div className="container">
        <div className="featured-programs-header">
          <h2 className="featured-programs-title">Kiemelt programjaink</h2>
          <p className="featured-programs-subtitle">
            Pillanatok a közösségi életből — valódi események és foglalkozások lakóinkkal.
          </p>
        </div>

        <div className={`featured-programs-grid ${loading ? 'is-loading' : ''}`}>
          {cards.map((card, index) => (
            <article
              key={card.id}
              className={`featured-program-card featured-program-card--${index % 4}`}
            >
              {card.imageUrl ? (
                <img
                  src={resolveMediaUrl(card.imageUrl)}
                  alt=""
                  className="featured-program-card__img"
                  loading="lazy"
                  decoding="async"
                />
              ) : (
                <div className="featured-program-card__placeholder" aria-hidden />
              )}
              <div className="featured-program-card__overlay">
                <span className="featured-program-card__tag">{card.tag}</span>
                <h3 className="featured-program-card__title">{card.title}</h3>
              </div>
            </article>
          ))}
        </div>

        <div className="featured-programs-actions">
          <button
            type="button"
            className="featured-programs-btn featured-programs-btn--primary"
            onClick={() => navigate('/naptar')}
          >
            Összes program
          </button>
          <button
            type="button"
            className="featured-programs-btn featured-programs-btn--secondary"
            onClick={() => navigate('/galeria')}
          >
            Galéria
          </button>
        </div>
      </div>
    </section>
  );
}

export default FeaturedProgramsSection;
